import Tooltip from './Tooltip'

export default function FormFieldTextArea (props) {
  return (
    <div className="wp-block-gds-lead-form__form-field">
      {props.label && (
        <label>
          {props.label}{props.required ? '*' : ''}
          {props.tooltip && <Tooltip>{props.tooltip}</Tooltip>}
        </label>
      )}
      <textarea
        rows="4"
        value={props.value}
        required={props.required}
        onChange={e => props.onChange?.(e.target.value)}
      />
    </div>
  )
}
